// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2n6Fz","topBottomGutter":"Layout_topBottomGutter__1Vdqe"};